import styled from 'styled-components';

import Button from '../../Button/Button';
import Heading from '../../Heading/Heading.styled';
import Container from '../Container.styled';

export const PageWrapperStyled = styled(Container)``;

export const MainTitleStyled = styled(Heading)`
  display: flex;
  gap: 10px;
  margin: 25px 0 10px;
  text-transform: capitalize;

  ${({ theme }) => `
    color: ${theme.primaryColour};  
  `}
`;

export const WrapperStyled = styled.div`
  display: flex;
  gap: 25px;

  ${({ theme }) => `
    ${theme.devices.touch} {
      flex-direction: column;
    }
  `}
`;

export const LeftSideStyled = styled.div`
  width: 100%;
`;

export const RightSideStyled = styled.div`
  width: 100%;

  ${({ theme }) => `
    ${theme.devices.desktop} {
        max-width: 300px;
    }
  `}
`;

export const TopRightSideStyled = styled(RightSideStyled)`
  display: flex;
  justify-content: center;
`;

export const NavSectionStyled = styled.div`
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.15);
`;

export const FaqButtonStyled = styled(Button)`
  display: flex;
  gap: 10px;
`;

export const FeedbackWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  ${({ theme }) => `
    a {
      color: ${theme.textColour};
      text-decoration: underline;
    }
  `}
`;

export const RightNavControlsStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: none;
  gap: 25px;

  ${({ theme }) => `
    ${theme.devices.mobile} {
      display: none;
    }
  `}
`;

export const InnerContainerStyled = styled(Container)`
  display: flex;
  padding-top: 30px;
  padding-bottom: 30px;
`;

export const RightSideTitleStyled = styled(Heading)`
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 15px;
  align-self: end;
`;
